import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncOnError, asyncSelectors
} from '../../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  setWarehouse: (defaultWarehouse) => ({ defaultWarehouse }),
  reset: () => null,
  asyncs: {
  }
}, 'lotReserved');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    rowModelType: 'serverSide',
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
  },
  Columns: [
    { headerName: 'Reserve type', field: 'ReserevedType', minWidth: 120, suppressSorting: true, },
    { headerName: 'Document', field: 'Document', minWidth: 120, suppressSorting: true, },
    { headerName: 'Lot Quantity', field: 'LotQuantityDisplay', type: 'numericColumn', minWidth: 150, suppressSorting: true, },
    { headerName: 'Entered', field: 'EnteredDate', minWidth: 120, suppressSorting: true, },
    { headerName: 'Expiry', field: 'ExpiryDate', minWidth: 120, suppressSorting: true, },
    { headerName: 'User', field: 'ResponsiblePerson', minWidth: 120, suppressSorting: true, },
    {
      headerName: 'Customer',
      field: 'CustomerIdDisplay',
      minWidth: 150,
      suppressSorting: true,
      hyperlinkParamGetter: (row) => {
        if (row.data && row.data.CustomerId) {
          return {
            CustomerId: row.data.CustomerId,
            CustomerAccountNumber: row.data.CustomerIdDisplay,
            FieldValue: row.data.CustomerIdDisplay
          };
        } else return null;
      },
      cellRenderer: 'hyperLinkRenderer',
      cellRendererParams: {
        link: '/customer-enquiry'
      }
    },
    { headerName: 'Name', field: 'CustomerName', minWidth: 350, suppressSorting: true, }
  ],
  Data: [],
  selectedFilters: {
    ReserveType: '1',
    CustomerId: 0,
  },
  filterRow: {
    formName: 'IEStockingLotReservedFilters',
    hidePreFilters: true,
    parameters: [
      {
        id: 0,
        type: 'AUTOCOMPLETE_FIELD',
        props: {
          label: 'Reserve type',
          name: 'ReserveType',
          required: true,
          options: [
            {
              value: '1',
              label: 'All'
            },
            {
              value: '2',
              label: 'General'
            },
            {
              value: '3',
              label: 'Quotes'
            },
            {
              value: '4',
              label: 'Enquiry'
            },
            {
              value: '5',
              label: 'Sales Order'
            }
          ]
        }
      },
      {
        id: 1,
        type: 'EX_LOOKUP_FIELD',
        props: {
          label: 'Customer',
          name: 'CustomerId',
          lookupName: 'Customer',
          size: 'small',
          required: false,
          searchScreenAPIParms: {Type: 'LOOKUP'}
        }
      }
    ]
  }
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.reset:
      return {
        ...state,
        data: initialState.data
      };
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }

    default:
      return state
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.inventoryEnquiry.stocking.lotReserved,
  {
    data: data => data.Data,
    selected: data => data.selected,
  }
)

const syncSelector = {
  isLoading: state => state.inventoryEnquiry.stocking.lotReserved.fetch_loading,
  gridOptions: state => state.inventoryEnquiry.stocking.lotReserved.data.gridOptions,
  columns: state => state.inventoryEnquiry.stocking.lotReserved.data.Columns,
  filterRow: state => state.inventoryEnquiry.stocking.lotReserved.data.filterRow,
  selectedFilters: state => state.inventoryEnquiry.stocking.lotReserved.data.selectedFilters,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)